const custAuth = {
    path: 'custAuth',
    name: 'custAuth',
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'auth',
        icon: 'HSIconfont hs-icon-shield',
        showRealm: ['SYSTEM', 'ADMIN']
    },
    children: [
        {
            path: 'custUser',
            name: 'custUser',
            component: () => import('@/views/custUser'),
            meta: { code: 'auth:user' }

        },
        {
            path: 'custRole',
            name: 'custRole',
            component: () => import('@/views/custRole'),
            meta: { code: 'auth:role' }

        },
    ]
};

export default custAuth;
